var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEditar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-editar 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.35,
    d: "M20.0109 3.98899C18.6929 2.67099 16.5559 2.67099 15.2379 3.98899L4.20792 14.998C3.90592 15.3 3.70492 15.687 3.63192 16.108L3.01692 19.675C2.88392 20.447 3.55492 21.117 4.32692 20.983L7.85192 20.37C8.26992 20.297 8.65592 20.097 8.95592 19.797L20.0109 8.76099C21.3299 7.44299 21.3299 5.30699 20.0109 3.98899Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.075 6.14399L17.848 10.917L19.832 8.93999L15.059 4.16699L13.075 6.14399Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.39192 17.5L3.01692 19.675C2.88392 20.447 3.55492 21.117 4.32692 20.983L6.49792 20.605L3.39192 17.5Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditar);
export default __webpack_public_path__ + "static/media/iconEditar.e7fc729fcf46ad2b10e53ca049fc0708.svg";
export { ForwardRef as ReactComponent };